import React from 'react'
import { ButtonEditInline } from '../../../../../Components/Buttons/ButtonEditInline'
import { ButtonArchiveInline } from '../../../../../Components/Buttons/ButtonArchiveInline'
import { Ticked } from 'Components/Ticked'
import { Td } from 'Components/Table/Td'
import { Tr } from 'Components/Table/Tr'
import { theme } from 'Assets/Styles/theme'
import * as CONST from '../../../../../Reducers/Location/const'

const LocationRow = ({
  location,
  handleModalArchiveShow,
  handleModalEditShow,
}) => {
  const isArchived = location.status === CONST.LOCATION_STATUS[2].value
  const archivedColor = isArchived ? theme.colors.primary : null
  const archivedName = isArchived ? ' (Archived)' : ''
  return (
    <Tr key={`location-row-${location.id}`}>
      <Td color={archivedColor}>{location.name + archivedName}</Td>
      <Td color={archivedColor}>{location.label}</Td>
      <Td color={archivedColor}>{location.type.name}</Td>
      <Td className="no-opacity">
        <Ticked ticked={location.moments.morning} />
      </Td>
      <Td className="no-opacity">
        <Ticked ticked={location.moments.lunch} />
      </Td>
      <Td className="no-opacity">
        <Ticked ticked={location.moments.afternoon} />
      </Td>
      <Td className="no-opacity">
        <Ticked ticked={location.isSheltered} />
      </Td>
      <Td className="no-opacity">
        <Ticked ticked={location.isEvent} />
      </Td>
      <Td className="no-opacity">
        <Ticked ticked={location.hasPermit} />
      </Td>
      <Td className="align-right no-opacity">
        {!isArchived && (
          <ButtonArchiveInline
            onClickHandler={() => handleModalArchiveShow(location.id)}
            title="Archive location"
          />
        )}
        <ButtonEditInline
          onClickHandler={() => handleModalEditShow(location.id)}
        />
      </Td>
    </Tr>
  )
}

export default LocationRow



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Locations/Components/LocationRow.jsx